'use strict';
import defa from './bg/background1.png';

export default [
    {name: 'Default', textstyle: {color: '#000000'}, background: defa },
];



// WEBPACK FOOTER //
// ./src/paperWallet/Themes.js